import { Box, Text, Stack, Container, Image } from "@chakra-ui/react";
import myDp from "../../assets/mydp.jpg";
import PushableButton from "../../components/buttons/PushableButton";
import { useNavigate } from "react-router-dom";

const MyStory = () => {
  const navigate = useNavigate();
  return (
    <Box bg="#101010" py={{ base: 16, md: 24 }} px={4}>
      <Container maxW="3xl">
        <Stack spacing={8} align="left" textAlign="left">
          {/* Profile Image + Name + Role */}
          <Stack direction="row" spacing={6} align="center">
            <Box p={2} bg="purple.500" borderRadius="full" boxShadow="lg">
              <Image
                src={myDp}
                alt="Founder"
                borderRadius="full"
                boxSize="120px"
                objectFit="cover"
              />
            </Box>
            <Box>
              <Text
                fontFamily="serif"
                fontSize="3xl"
                fontWeight="bold"
                color="gray.50"
              >
                Santhosh Nayak
              </Text>
              <Text fontSize="md" color="gray.50" mt={1}>
                Creator of Bellu.ai
              </Text>
            </Box>
          </Stack>

          {/* Title */}
          <Text
            fontSize="4xl"
            fontWeight="semibold"
            color="gray.50"
            mt={6}
            fontFamily="serif"
          >
            The Origin
          </Text>

          {/* Paragraphs */}
          <Stack
            spacing={4}
            fontSize={{ base: "md", md: "lg" }}
            pb={"2rem"}
            color="gray.50"
            lineHeight="1.8"
          >
            <Text>
              I didn’t start Bellu.ai to build a company. I built it because I
              needed it.
            </Text>
            <Text>
              I’ve always been curious — not just about one subject, but about
              everything. From AI to quantum physics, robotics to nanotech and
              more, I wanted to understand how the world works — and how I could
              build it better.
            </Text>
            <Text>
              But traditional learning felt slow. Videos were passive. Courses
              were boring. And most platforms talked down to me.
            </Text>
            <Text>
              I didn’t want to study tech — I wanted to <strong>live</strong>{" "}
              it. Not for exams, but to become something more.
            </Text>
            <Text>
              Maybe even the next Leonardo da Vinci, Nikola Tesla, or a
              visionary entrepreneur of the future.
            </Text>
            <Text>
              That’s why I built Bellu.ai — to create the kind of platform I
              always wished existed. A space where I could play with ideas,
              visualize concepts, and connect across fields.
            </Text>
            <Text>
              Bellu.ai is not for everyone. It’s for the dreamers, the misfits,
              the ones who build before they’re told to. People like me. People
              like you.
            </Text>
            <Box mt={"1rem"}>
              <PushableButton
                title="Explore Bellu.ai"
                onClick={() => navigate("/dashboard/learn")}
              ></PushableButton>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default MyStory;
